import { render, staticRenderFns } from "./rating_stars.vue?vue&type=template&id=e87147f6&"
import script from "./rating_stars.vue?vue&type=script&lang=js&"
export * from "./rating_stars.vue?vue&type=script&lang=js&"
import style0 from "./rating_stars.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports